import { render, staticRenderFns } from "./YKCNotes.vue?vue&type=template&id=3ba1770b&"
import script from "./YKCNotes.vue?vue&type=script&lang=js&"
export * from "./YKCNotes.vue?vue&type=script&lang=js&"
import style0 from "./YKCNotes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports